import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { InjectionService } from '../_services/injection.service';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { InjectionDataBatch } from '../_models/injection-data-batch';

import { UserSubmittableDataGridComponent } from '../user-submittable-data-grid/user-submittable-data-grid.component';

@Component({
  selector: 'app-injection-data-grid2',
  templateUrl: './injection-data-grid2.component.html',
  styleUrls: ['./injection-data-grid2.component.css']
})
export class InjectionDataGrid2Component extends UserSubmittableDataGridComponent implements OnInit {


  constructor(
    public injectionService: InjectionService,
    formBuilder: FormBuilder
  ) {

    super(formBuilder, injectionService);

    //Subscribe to the current injection batch
    this.injectionService.currentInjectionBatch.subscribe((newInjectionDataBatch: InjectionDataBatch) => {

      this.clearForm();

      if(newInjectionDataBatch != null) {
        //When we have a
        this.buildForm(newInjectionDataBatch);
      }
      
    });
  }

}
